export default __webpack_public_path__ + "locales/it/CreateEditRoomDialog.json?hash=e0a0c5665eebfb6e860cdd0db863d7d7";